export const SET_TIMECARD_LOADING = 'SET_TIMECARD_LOADING'
export const SET_TIMECARD = 'SET_TIMECARD'


